import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function StarsIcon(props: IconProps) {
    return <Icon {...props} iconKey={"stars"}/>
}
